import PageBuilder from '../../components/panel/PageBuilder'
import {Button} from 'antd'
import {DollarOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import {useState} from 'react'
import ModalWithForm from '../users/ModalWithForm'
import {
    LicenseFilter,
    LicenseInfoType,
    LicenseType,
    useCreateLicenseMutation,
    useGetLicensesQuery,
    useUpdateLicenseMutation
} from '../../api/licenseApi'
import {Form} from 'antd'
import LicenseForm from './LicenseForm'
import {useAppSelector} from '../../hooks'
import {useNavigate} from 'react-router-dom'
import ExtendedTable from "../../components/ExtendedTable";
import {useFilterTable} from "../../hooks/useFilterTable";

const Licenses = () => {
    const navigate = useNavigate()
    const {role} = useAppSelector(state => state.user)

    const [formCreate] = Form.useForm<LicenseInfoType>()
    const [formUpdate] = Form.useForm<LicenseInfoType>()

    const [isModalOpenCreate, setIsModalOpenCreate] = useState(false)
    const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false)

    const [filter, setFilter] = useState<LicenseFilter>({
        page: 1,
        name: '',
    })

    const [create, resultsCreate] = useCreateLicenseMutation()
    const [update, resultsUpdate] = useUpdateLicenseMutation()
    const {data, isLoading, refetch} = useGetLicensesQuery(filter)

    const [filterByText] = useFilterTable<LicenseFilter>(filter, setFilter);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ...filterByText('name')
        },
        {
            title: 'Interval',
            dataIndex: 'interval',
            key: 'interval'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_: void, license: LicenseType) => (
                <>
                    {
                        role === 'admin' && (
                            <Button
                                onClick={() => {
                                    const {product} = license
                                    const productIds = product.map(item => item.id)
                                    formUpdate.setFieldsValue({
                                        id: license.id,
                                        name: license.name,
                                        dealer: license.dealer,
                                        description: license.description,
                                        brand_id: license.brand.id,
                                        is_show_all: license.is_show_all,
                                        product: productIds
                                    })
                                    setIsModalOpenUpdate(true)
                                }}
                                type="link"
                                size="small">
                                <EditOutlined/>
                            </Button>
                        )
                    }

                    {
                        role === 'account manager' && (
                            <Button
                                onClick={() => {
                                    const {id} = license
                                    navigate(`/licenses/price/${id}`)
                                }}
                                type="link"
                                size="small">
                                <DollarOutlined/>
                            </Button>
                        )
                    }
                </>
            )
        }
    ]

    return (
        <PageBuilder title="Licenses" documentTitle="Licences">
            {
                role === 'admin' && (
                    <div style={{marginBottom: 20}}>
                        <Button type="primary" onClick={() => setIsModalOpenCreate(true)}>
                            <PlusOutlined/> Create License
                        </Button>
                    </div>
                )
            }

            <ExtendedTable
                data={data}
                isLoading={isLoading}
                dataKey="license"
                columns={columns}
                incrementPage={1}
                onChange={e => setFilter(prevState => ({...prevState, page: e}))}
            />

            <ModalWithForm
                title="Create License"
                isOpen={isModalOpenCreate}
                setIsOpen={setIsModalOpenCreate}
                isLoading={resultsCreate.isLoading}
                submit={formCreate.submit}>
                <LicenseForm
                    setIsModalOpen={setIsModalOpenCreate}
                    refetch={refetch}
                    form={formCreate}
                    onFinish={create}
                    mode="creating"
                />
            </ModalWithForm>

            <ModalWithForm
                title="Update License"
                isOpen={isModalOpenUpdate}
                setIsOpen={setIsModalOpenUpdate}
                isLoading={resultsUpdate.isLoading}
                submit={formUpdate.submit}>
                <LicenseForm
                    setIsModalOpen={setIsModalOpenUpdate}
                    refetch={refetch}
                    form={formUpdate}
                    onFinish={update}
                />
            </ModalWithForm>
        </PageBuilder>
    )
}

export default Licenses
